'use strict';
module.exports = { XMLHttpRequest: XMLHttpRequest };



//////////////////
// WEBPACK FOOTER
// ./~/twilio-client/browser/xmlhttprequest.js
// module id = IbSi
// module chunks = 0